import {
  Box,
  Button,
  NumberInput,
  NumberInputField,
  Select,
  Td,
  Text,
  Tooltip,
  Tr
} from "@chakra-ui/react";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { ClientClassificationType } from "models/client_classification_type";
import { ProdutoItemType } from "models/product_item_type";
import { ProductType } from "models/product_type";
import { ProjectCategoryItem } from "models/project_type";
import { OptionType } from "models/select_mode";
import { useEffect, useState } from "react";
import formatNumber from "views/admin/order/hooks/formatNumber";

interface IFinanceItemRow {
  item1: ProjectCategoryItem;
  index1: number;
  index: number;
  editItem: (data: ProjectCategoryItem, tipo: string, value: string) => void;
  produtos: ProductType[];
  unidades: ClientClassificationType[];
}

const FinanceItemRow = ({
  item1,
  index,
  index1,
  editItem,
  produtos,
  unidades,
}: IFinanceItemRow) => {
  const [produtoTexto, setProdutoTexto] = useState("");
  const [selectedProduto, setSelectedProduto] = useState<ProductType>(null);
  const [produto, setProduto] = useState("");
  const [descricao, setDescricao] = useState("");
  const [unidade, setUnidade] = useState("");
  const [unidadeTexto, setUnidadeTexto] = useState("");
  const [quantidade, setQuantidade] = useState("1");
  const [valor, setValor] = useState("");
  const [total, setTotal] = useState(0);
  const [percentualReduzido, setPercentualReduzido] = useState("");
  const [valorReduzido, setValorReduzido] = useState(0);
  const [percentualManejo, setPercentualManejo] = useState("");
  const [valorManejo, setValorManejo] = useState(0);
  const [selectedProdutoItens, setSelectedProdutoItens] =
    useState<ProdutoItemType>();

  const [unidadesDisponiveis, setUnidadesDisponiveis] = useState<
    ClientClassificationType[]
  >([]);
  const [unidadePadrao, setUnidadePadrao] =
    useState<ClientClassificationType>();

  const changeProduto = (item: string) => {
    const prdUn = produtos?.find((value) => value.id === item);
    setSelectedProduto(prdUn);
    const unDisp: ClientClassificationType[] = [];
    unidades?.forEach((v) => {
      const existe = prdUn?.ProdutoUnidade?.find(
        (un) => un.unidadeMedidaId === v.id
      );
      if (existe) {
        unDisp.push(v);
        if (existe.principal) {
          changeUnidade(existe.unidadeMedidaId);
          const selected = prdUn.ProdutoUnidade.find(
            (prd) => prd?.unidadeMedidaId === existe.unidadeMedidaId
          );
          if (selected) {
            setSelectedProdutoItens(selected);
            const media =
              (Number(selected.valorMin) + Number(selected.valorMax)) / 2;
            setValor(Number(media).toFixed(2));
          }
          setUnidadePadrao({
            id: existe.unidadeMedidaId,
            idEmpresa: prdUn.idEmpresa,
            nome: v.nome,
          });
        }
      }
    });

    setUnidadesDisponiveis(unDisp);
    setProdutoTexto(prdUn.nome);
    setProduto(item);
    editItem(item1, "produto", item);
  };

  const changeReducao = (item: string) => {
    setPercentualReduzido(item);
  };

  const changeManejo  = (item: string) => {
    setPercentualManejo(item);
  };

  const changeUnidade = (item: string) => {
    const un = unidades?.find((val) => val.id === item);
    const prdUn = produtos?.find((value) => value.id === produto);
    const selected = prdUn?.ProdutoUnidade.find(
      (prd) => prd?.unidadeMedidaId === item
    );
    if (selected) {
      editItem(item1, "unidade", item);
      setSelectedProdutoItens(selected);
      const media = (Number(selected.valorMin) + Number(selected.valorMax)) / 2;
      setValor(Number(media).toFixed(2));
      setUnidade(item);
      setUnidadeTexto(un.nome);
      const valorTotal = media * Number(quantidade);
      setTotal(valorTotal);
    }
  };
  const changeQuantidade = (item: string) => {
    setQuantidade(item);
  };

  const changeValor = (item: string) => {
    setValor(item);
  };

  const calculate = (item: string) => {
    editItem(item1, "valor", item);

    let totalUn = Number(valor);

    let total = totalUn * Number(quantidade);

    setTotal(total);
    changeValor(totalUn.toString());
  };

  const calcReducao = (item: string) => {
    editItem(item1, "reducao", item);
    const val = (Number(item) * total) / 100;
    setValorReduzido(val);

  }

  const calcManejo = (item: string) => {
    editItem(item1, "manejo", item);
    const val = (Number(item) * total) / 100;
    setValorManejo(val);

  }

  useEffect(() => {
    if (item1 && produtos) {
      setProdutoTexto(
        produtos?.find((prd) => prd.id === item1.produtoId)?.nome
      );
      setProduto(item1.produtoId);
      setValorManejo(Number(item1.valorManejo));
      setPercentualManejo(item1.porcentagemManejo);
      setValorReduzido(Number(item1.valorReducao));
      setPercentualReduzido(item1.porcentagemReducao);
      setDescricao(item1.descricao);
      setUnidade(item1.unidadeMedidaId);
      setUnidadeTexto(
        unidades?.find((un) => un.id === item1.unidadeMedidaId)?.nome
      );
      setQuantidade(Number(item1.quantidade).toFixed(2));
      setValor(Number(item1.valorUn).toFixed(2));
      setTotal(item1.valorTotal);
      const prdUn = produtos?.find((value) => value.id === item1.produtoId);
      setSelectedProduto(prdUn);
      const unDisp: ClientClassificationType[] = [];
      unidades?.forEach((v) => {
        const existe = prdUn?.ProdutoUnidade.find(
          (un) => un.unidadeMedidaId === v.id
        );
        if (existe) {
          unDisp.push(v);
          if (existe.principal) {
            const selected = prdUn?.ProdutoUnidade.find(
              (prd) => prd?.unidadeMedidaId === existe.unidadeMedidaId
            );
            if (selected) {
              setSelectedProdutoItens(selected);
            }
          }
        }
      });

      setUnidadesDisponiveis(unDisp);
    }
  }, [item1, produtos, unidades]);

  return (
    <Tr>
      <Td>
        <Box width={250} alignSelf={"flex-start "}>
          <Box w={"100%"}>
            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size="md"
              onChange={(e) => changeProduto(e.value)}
              placeholder="Buscar..."
              isDisabled={false}
              name={"Produto"}
              options={produtos?.map((item) => {
                return {
                  label: item?.nome,
                  value: item?.id,
                };
              })}
              value={{
                label: produtoTexto,
                value: produto,
              }}
            />
          </Box>
        </Box>
      </Td>

      <Td>
        <Select
          size="md"
          onChange={(e) => changeUnidade(e.target.value)}
          isDisabled={true}
          style={{
            width: 150,
          }}
          disabled={item1.travado}
          name={`unidade-${index1}-${index}`}
        >
          {unidadesDisponiveis.map((item) => (
            <option value={item?.id}>{item?.nome}</option>
          ))}
        </Select>
      </Td>
      <Td>
        <NumberInput
        style={{
          width: 100,
        }}
          precision={2}
          isDisabled={item1.travado}
          step={1}
          min={1}
          name={`quantidade--${index1}-${quantidade}`}
          value={quantidade}
          onChange={(e) => changeQuantidade(e)}
          onBlur={(e) => {
            if(Number(e.target.value) > 0) {
            editItem(item1, "quantidade", e.target.value)}}}
        >
          <NumberInputField />
        </NumberInput>
      </Td>
      <Td>
        <Tooltip
          label={`O valor deve ser entre ${formatNumber(
            isNaN(Number(selectedProdutoItens?.valorMin))
              ? 0
              : formatNumber(Number(selectedProdutoItens?.valorMin))
          )} e ${formatNumber(
            isNaN(Number(selectedProdutoItens?.valorMax))
              ? 0
              : formatNumber(Number(selectedProdutoItens?.valorMax))
          )}`}
        >
          <NumberInput
            isDisabled={item1.travado}
            precision={2}
            style={{
              width: 120,
            }}
            name={`valor--${index1}-${valor}`}
            value={valor}
            onChange={(e) => changeValor(e)}
            onBlur={(e) =>{ 
              if(Number(e.target.value) > 0) {
              calculate(e.target.value)}}}
          >
            <NumberInputField />
          </NumberInput>
        </Tooltip>
      </Td>
      <Td>
        <Text
          textAlign="left"
          color={"black"}
          fontSize={14}
          alignSelf={"center"}
        >
          {formatNumber(Number(total))}
        </Text>
      </Td>
      <Td>
        <NumberInput
          isDisabled={item1.travado}
          precision={2}
          style={{
            width: 100,
          }}
          name={`valorReduzido--${index1}-${valor}`}
          value={percentualReduzido}
          onChange={(e) => changeReducao(e)}
          onBlur={(e) => {

              calcReducao(e.target.value)
              calcManejo(percentualManejo)

          }}
        >
          <NumberInputField />
        </NumberInput>
      </Td>
      <Td>
        <Text
          textAlign="left"
          color={"black"}
          fontSize={14}
          alignSelf={"center"}
        >
          {formatNumber(Number(valorReduzido))}
        </Text>
      </Td>
      <Td>
        <NumberInput
          isDisabled={item1.travado}
          precision={2}
          name={`valorManej0--${index1}-${valor}`}
          value={percentualManejo}
          style={{
            width: 100,
          }}
          onChange={(e) => changeManejo(e)}
          onBlur={(e) => {

              calcManejo(e.target.value)
            
          }}
        >
          <NumberInputField />
        </NumberInput>
      </Td>
      <Td>
        <Text
          textAlign="left"
          color={"black"}
          fontSize={14}
          alignSelf={"center"}
          width={150}
        >
          {formatNumber(Number(valorManejo))}
        </Text>
      </Td>
      <Td>
        <Button
          onClick={() => {

            editItem(item1, "travado", "");

          }}
          colorScheme={item1.travado ? "red" : "green"}
          variant="ghost"
          ml="1"
        >
          {item1.travado ? "Liberar" : "Travar"}
        </Button>
      </Td>
    </Tr>
  );
};
export default FinanceItemRow;
